import {
  BillingStatus,
  IBillingPayment,
  IBillingPaymentApi,
  IBillingPaymentSchedule,
  IBillingPaymentScheduleApi,
  IBillingRefund,
  IBillingRefundApi,
} from "./billings";
import { IContainer } from "./container";
import { ISelectOption } from "./select";

export interface IUpdateIsPaidStatusRequest {
  locationId: number;
  isPaid: PaymentStatus;
  year: ISelectOption["value"];
}

export interface ICollectionPointBillingApi {
  amount: string | null;
  net_amount: string | null;
  is_closed: boolean | null;
}

export interface ICollectionPointBilling {
  amount: number | null;
  netAmount: number | null;
  isClosed: boolean | null;
}

export interface ICollectionPointApi {
  locationId: number;
  administrationId: number;
  name: string;
  address: string;
  householdMembersCount: number;
  degreeOfSeparation: number;
  wastePerHouseholdMember: number | null;
  containers: IContainer[];
  isPO: boolean;
  invitationToken: null | string;
  invitationStatus: InvitationStatus;
  isPaid: boolean;
  year: number;
  disableTime: string | null;
  enableTime: string | null;
  billing: ICollectionPointBillingApi | null;
  paymentSchedule: IBillingPaymentScheduleApi | null;
  payments: IBillingPaymentApi[] | null;
  refunds: IBillingRefundApi[] | null;
}

export interface ICollectionPoint {
  locationId: number;
  administrationId: number;
  name: string;
  address: string;
  householdMembersCount: number;
  degreeOfSeparation: number;
  wastePerHouseholdMember: number | null;
  containers: IContainer[];
  isPO: boolean;
  invitationToken: null | string;
  invitationStatus: InvitationStatus;
  isPaid: boolean;
  year: number;
  disableTime: string | null;
  enableTime: string | null;
  billing: ICollectionPointBilling | null;
  billingStatus: BillingStatus | null;
  paymentSchedule: IBillingPaymentSchedule | null;
  payments: IBillingPayment[] | null;
  refunds: IBillingRefund[] | null;
}

export enum InvitationStatus {
  NotInvited,
  Invited,
  Registered,
}

export enum PaymentStatus {
  Paid = 1,
  Unpaid,
  Moved,
}

export interface ICollectionPointDetailResponse {
  locationDetail: ICollectionPoint;
}

export interface IInviteToMobileAppResponse {
  token: string;
  message?: string;
}

export interface IUpdateLocationIsPaidStatusResponse {
  LocationId: number;
  Year: number;
  Status: PaymentStatus;
}

export interface ICollectionPointPut {
  year: number;
  payment_schedule?: Partial<IBillingPaymentScheduleApi>;
  payments?: {
    period: string;
    disable: boolean;
  }[];
  refunds?: {
    id: number;
    disable: boolean;
  }[];
}

export type PutCollectionPointPaymentArgs = {
  period: string;
  isPaid: boolean;
};

export type PutCollectionPointRefundArgs = {
  id: number;
  isReturned: boolean;
};
